export function getView(width) {
  let newView = "MobileView";
  if (width > 1100) {
    newView = "DesktopView";
  } else if (width > 991) {
    newView = "TabLandView";
  } else if (width > 767) {
    newView = "TabView";
  }
  return newView;
}
const actions = {
  COLLPSE_CHANGE: "COLLPSE_CHANGE",
  CHANGE_OPEN_KEYS: "CHANGE_OPEN_KEYS",
  TOGGLE_ALL: "TOGGLE_ALL",
  CHANGE_CURRENT: "CHANGE_CURRENT",
  TOGLLE_SHOW_BREADCRUMB: "TOGLLE_SHOW_BREADCRUMB",
  TOGLLE_FIXED_NAVBAR: "TOGLLE_FIXED_NAVBAR",
  CHANGE_BRED_HEIGHT: "CHANGE_BRED_HEIGHT",
  SET_USER_DATA: "SET_USER_DATA",
  GET_USER_DATA: "GET_USER_DATA",
  UPDATE_EXTENDED_PROFILE: 'UPDATE_EXTENDED_PROFILE',
  UPDATE_EXTENDED_PROFILE_SUCCESS: 'UPDATE_EXTENDED_PROFILE_SUCCESS',
  UPDATE_EXTENDED_PROFILE_FAILED: 'UPDATE_EXTENDED_PROFILE_FAILED',
  UPDATE_EXTENDED_PROFILE_RESET: 'UPDATE_EXTENDED_PROFILE_RESET',
  UPDATE_PASSWORD: 'UPDATE_PASSWORD',
  UPDATE_PASSWORD_SUCCESS: 'UPDATE_PASSWORD_SUCCESS',
  UPDATE_PASSWORD_FAILED: 'UPDATE_PASSWORD_FAILED',
  UPDATE_PASSWORD_RESET: 'UPDATE_PASSWORD_RESET',
  UPDATE_CONTACT_ADDRESSES: 'UPDATE_CONTACT_ADDRESSES',

  TOGGLE_BILLING_ADDRESS: 'TOGGLE_BILLING_ADDRESS',

  BILLING_POSTCODE_LOOKUP: 'BILLING_POSTCODE_LOOKUP',
  CONTACT_POSTCODE_LOOKUP: 'CONTACT_POSTCODE_LOOKUP',
  ON_BILLING_POSTCODE_LOOKUP: 'ON_BILLING_POSTCODE_LOOKUP',
  ON_CONTACT_POSTCODE_LOOKUP: 'ON_CONTACT_POSTCODE_LOOKUP',

  ON_UPDATE_ADDRESS: 'ON_UPDATE_ADDRESS',
  ON_ADDRESS_SAVED: 'ON_ADDRESS_SAVED',
  ON_RESET_ADDRESS_SAVED: 'ON_RESET_ADDRESS_SAVED',

  toggleCollapsed: () => ({
    type: actions.COLLPSE_CHANGE
  }),
  toggleAll: (width, height) => {
    const view = getView(width);
    const collapsed = view !== "DesktopView";
    return {
      type: actions.TOGGLE_ALL,
      collapsed,
      view,
      height
    };
  },
  changeOpenKeys: openKeys => ({
    type: actions.CHANGE_OPEN_KEYS,
    openKeys
  }),
  changeCurrent: current => ({
    type: actions.CHANGE_CURRENT,
    current
  }),
  toggleShowBreadCrumb: () => ({ type: actions.TOGLLE_SHOW_BREADCRUMB }),
  toggleFixedNavbar: () => ({ type: actions.TOGLLE_FIXED_NAVBAR }),
  changeBredHeight: bredHeight => ({
    type: actions.CHANGE_BRED_HEIGHT,
    bredHeight
  }),
  getUserData: () => ({
    type: actions.GET_USER_DATA,
  }),
  setUserData: userData => ({
    type: actions.SET_USER_DATA,
    userData
  }),

  updateExtendedProfile: payload => ({
    type: actions.UPDATE_EXTENDED_PROFILE,
    payload
  }),
  updateExtendedProfileSuccess: response => ({
    type: actions.UPDATE_EXTENDED_PROFILE_SUCCESS,
    payload: response
  }),
  updateExtendedProfileFailed: response => ({
    type: actions.UPDATE_EXTENDED_PROFILE_FAILED,
    payload: response
  }),
  updateExtendedProfileReset: () => ({
    type: actions.UPDATE_EXTENDED_PROFILE_RESET
  }),

  updatePassword: payload => ({
    type: actions.UPDATE_PASSWORD,
    payload
  }),
  updatePasswordSuccess: response => ({
    type: actions.UPDATE_PASSWORD_SUCCESS,
    payload: response
  }),
  updatePasswordFailed: response => ({
    type: actions.UPDATE_PASSWORD_FAILED,
    payload: response
  }),
  updatePasswordReset: () => ({
    type: actions.UPDATE_PASSWORD_RESET
  }),
  updateContactAddresses: response => ({
    type: actions.UPDATE_CONTACT_ADDRESSES,
    payload: response
  }),
  billingPostcodeLookup: payload => ({
    type: actions.BILLING_POSTCODE_LOOKUP,
    payload
  }),
  contactPostcodeLookup: payload => ({
    type: actions.CONTACT_POSTCODE_LOOKUP,
    payload
  }),
  onBillingPostcodeLookup: payload => ({
    type: actions.ON_BILLING_POSTCODE_LOOKUP,
    payload
  }),
  onContactPostcodeLookup: payload => ({
    type: actions.ON_CONTACT_POSTCODE_LOOKUP,
    payload
  }),
  updateAddress: payload => ({
    type: actions.ON_UPDATE_ADDRESS,
    payload
  }),
  onAddressSaved: () => ({
    type: actions.ON_ADDRESS_SAVED
  }),
  resetAddressSaved: () => ({
    type: actions.ON_RESET_ADDRESS_SAVED
  }),
  toggleBillingAddress: () => ({
    type: actions.TOGGLE_BILLING_ADDRESS
  }),
};
export default actions;



// WEBPACK FOOTER //
// ./src/redux/app/actions.js